import { render, staticRenderFns } from "./newsMoreList.vue?vue&type=template&id=068bea9c"
import script from "./newsMoreList.vue?vue&type=script&lang=js"
export * from "./newsMoreList.vue?vue&type=script&lang=js"
import style0 from "./newsMoreList.vue?vue&type=style&index=0&id=068bea9c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports